import {
  FlowNotableObject,
  type FlowUpdateNotableObjectBlock,
  FlowUpdateNotableObjectConfigSchema,
} from 'flow-schema';

import { UpdateNotableObjectFormFields } from './FormFields';
import { UpdateNotableObjectOutputContent } from './OutputContent';
import { UpdateNotableObjectDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const updateNotableObjectConfig: BlockConfigProps<FlowUpdateNotableObjectBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'UpdateNotableObject',
  defaultConfig: {
    notableObject: FlowNotableObject.Patient,
    payload: '',
  },
  configFields: {
    schema: FlowUpdateNotableObjectConfigSchema,
    FormFields: UpdateNotableObjectFormFields,
  },
  OutputContentComponent: UpdateNotableObjectOutputContent,
  documentationMarkdown: UpdateNotableObjectDocumentationMarkdown,
};
